import { buildHtml, KitchenSinkRoute, RouteSlotInput } from '@luks/ui';

export const mapWysiwygContent = (
  input: WysiwygFragment,
): RouteSlotInput<typeof KitchenSinkRoute, 'body', 'FormattedText'> => ({
  key: 'FormattedText',
  input: {
    Content: buildHtml(input.textHtml || ''),
  },
});
